import clsx from 'clsx';
import applicationStatuses from './constants/applicationStatuses';

/**
 * The orders status properties.
 */
type ApplicationsStatusProps = {
	name: string;
};

/**
 * The applications status component.
 */
function ApplicationsStatus({ name }: ApplicationsStatusProps) {
	const status = applicationStatuses?.find((status) => status.value === name);
	
	return (
		<div className={clsx('inline text-md font-semibold py-1 px-3 rounded-full truncate', status?.color)}>
			{status?.name || name?.replace(/[_-]/g, ' ')?.replace(/^\w/, (c) => c.toUpperCase())}
		</div>
	);
}

export default ApplicationsStatus;
